module.exports = __webpack_public_path__ + "19a9779be4643ca637c89e3485699ebe.png";